import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import packageJSON from '../../package.json';
import { getStorageItem, removeStorageItem } from './localStorage';

const NEST_URL = process.env.REACT_APP_NEST_CUSTOMERS;
const NODE_URL = process.env.REACT_APP_NODE_API;

export const apiV1 = axios.create({
  baseURL: `${NEST_URL}v1/api/yooga/`,
});

export const apiV2 = axios.create({
  baseURL: `${NEST_URL}v2/api/yooga/`,
});

export const apiNestNode = axios.create({
  baseURL: `${NEST_URL}node-api/`,
});

export const apiInstallationApp = axios.create({
  baseURL: `${NEST_URL}v2/api/yooga/installation/app/`,
});

export const apiInstallationDelivery = axios.create({
  baseURL: `${NEST_URL}v2/api/yooga/installation/delivery/`,
});

export const apiDefault = axios.create({
  baseURL: `${NEST_URL}v1/api/`,
});

export const nodeApi = axios.create({
  baseURL: NODE_URL,
});

// ------------------------------------------------------------
// MIDDLEWARES
// ------------------------------------------------------------

function handleHeaders(config: InternalAxiosRequestConfig) {
  const token = getStorageItem('token');

  // Append default headers
  config.headers!['Accept'] = 'application/json';
  config.headers!['Content-Type'] = 'application/json';
  config.headers!['version'] = packageJSON.version;
  config.headers!['timezone-version'] = 'true';
  config.headers!['auto-increase'] = 'true';

  // Append JWT Token if exists
  if (token) {
    config.headers!['Authorization'] = `Bearer ${token}`;
  }

  return config;
}

function handleRequestError(error: Error) {
  return Promise.reject(error);
}

function handleUnauthorized(error: AxiosError) {
  if (error.response && error.response?.status === 401) {
    removeStorageItem('token');
    window.location.href = '/login';
  }
  return Promise.reject(error);
}

apiV1.interceptors.request.use(handleHeaders, handleRequestError);
apiV1.interceptors.response.use(null, handleUnauthorized);

apiV2.interceptors.request.use(handleHeaders, handleRequestError);
apiV2.interceptors.response.use(null, handleUnauthorized);

apiDefault.interceptors.request.use(handleHeaders, handleRequestError);
apiDefault.interceptors.response.use(null, handleUnauthorized);

apiNestNode.interceptors.request.use(handleHeaders, handleRequestError);
apiNestNode.interceptors.response.use(null, handleUnauthorized);

apiInstallationApp.interceptors.request.use(handleHeaders, handleRequestError);
apiInstallationApp.interceptors.response.use(null, handleUnauthorized);

apiInstallationDelivery.interceptors.request.use(
  handleHeaders,
  handleRequestError,
);
apiInstallationDelivery.interceptors.response.use(null, handleUnauthorized);
